export default "__VITE_ASSET__UDTAG4K1__"